module.exports = __webpack_public_path__ + "img/Logo_ENAC.3a9ed7e2.png";